<template>
  <div class="loading-indicator-wrapper">
    <div class="loading-indicator">
      <div class="segment segment-blue"></div>
      <div class="segment segment-yellow"></div>
      <div class="segment segment-teal"></div>
      <div class="segment segment-red"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LoadingIndicator'
  }
</script>

<style lang="scss" scoped>
  .loading-indicator-wrapper {
    z-index: 998;
    @apply w-full pin-t pin-l fixed;
  }

  .loading-indicator {
    height: 3px;
    animation: grow 5s infinite linear;
    @apply flex absolute w-full;

    .segment {
      width: 25%;
      height: 3px;

      &.segment-orange {
        @apply bg-lerner-orange;
      }

      &.segment-blue {
        @apply bg-lerner-blue;
      }

      &.segment-yellow {
        @apply bg-lerner-yellow;
      }

      &.segment-teal {
        @apply bg-lerner-teal;
      }

      &.segment-red {
        @apply bg-lerner-red;
      }
    }

    @keyframes grow {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }
  }
</style>